export class LoadingService {

  public loading = false;
  public conteudo = 'Aguarde';

  exibirLoading(conteudo: string | null) {
    this.conteudo = conteudo == null ? 'Aguarde' : conteudo;
    this.loading = true;
  }

  esconderLoading() {
    this.loading = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared-layout/loading/loading.service.ts